<template>
  <Card :title="title" show-status-bar margin="mb-4">
      <DetailField :label="__DICT__.passengerView.group">
        {{ lesson.group || (__DICT__.notAvailable || 'Not available') }}
        <router-link v-if="showLink"
                     :to="`/lesson/${lesson.reference.split('-')[2]}`"
                     class="btn btn-icon btn-sm btn-ghost-primary ms-2">
          <IconSquareArrowRight />
        </router-link>
      </DetailField>
      <DetailField :label="__DICT__.meetingPoint">
        {{ lesson.meetingPoint || (__DICT__.notAvailable || 'Not available') }}
        <a v-if="lesson.meetingPointUrl"
           class="btn btn-icon btn-sm btn-ghost-primary ms-2"
           :href="lesson.meetingPointUrl"
           target="_blank">
          <IconMapPin/>
        </a>
      </DetailField>
      <DetailField :label="__DICT__.time" :value="lesson.times || (__DICT__.notAvailable || 'Not available')" />
      <DetailField v-if="lesson.notes" :label="__DICT__.notes" :value="lesson.notes" />
  </Card>
</template>

<script setup>
import { IconSquareArrowRight, IconMapPin} from '@tabler/icons-vue'
import { Card, DetailField } from "@/components/atomic";



const props = defineProps({
  lesson: {
    type: Object,
    required: true,
    validator: (value) => {
      return value && typeof value === 'object' && 'group' in value
    }
  },
  title: {
    type: String,
    default: __DICT__.lessonDetails
  },
  showLink: {
    type: Boolean,
    default: false
  }
})
</script>